import { useCallback } from 'react'
import { connect } from 'react-redux'
import Sticky from 'react-sticky-el'
import { Dispatch } from '@reduxjs/toolkit'
import styled from 'styled-components'

import type { GlobalState } from '../types'
import { NotificationsError } from './Error'
import { removeNotification } from './notifications-actions'
import { Success } from './Success'
import type { NotificationType } from './types'
import { Warning } from './Warning'

const Container = styled.div`
  z-index: 2;
  width: 100%;
  max-width: 800px; /* IE */
  position: sticky;
  top: 0;
`

type NotificationsProps = {
  notifications: NotificationType[]
  removeNotification(name: string): void
}

const NotificationsComponent = (props: NotificationsProps) => {
  const { notifications, removeNotification } = props

  const renderBanner = useCallback((notification: NotificationType) => {
    const handleClose = notification.canDismiss
      ? () => removeNotification(notification.name)
      : undefined
    switch(notification.severity) {
      case 'warning':
        return (
          <Warning
            key={notification.name}
            title={notification.title}
            handleClose={handleClose}
          >
            {notification.body}
          </Warning>
        )
      case 'error':
        return (
          <NotificationsError
            key={notification.name}
            title={notification.title}
            handleClose={handleClose}
          >
            {notification.body}
          </NotificationsError>
        )
      case 'success':
      default:
        return (
          <Success
            key={notification.name}
            title={notification.title}
            handleClose={handleClose}
          >
            {notification.body}
          </Success>
        )
    }
  }, [removeNotification])

  if (notifications.length === 0) {
    return null
  }

  return (
    <Container>
      <Sticky>
        {notifications.map(renderBanner)}
      </Sticky>
    </Container>
  )
}

const mapStateToProps = (state: GlobalState) => ({
  notifications: state.notifications.notifications
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  removeNotification: (name: string) => dispatch(removeNotification(name))
})

const Notifications = connect(mapStateToProps, mapDispatchToProps)(NotificationsComponent)

export {
  Notifications,
  NotificationsComponent
}
